import { Component, Prop, State, h, Event, EventEmitter, Fragment } from '@stencil/core';
import { Tag } from '../../global/models'
import { TagData } from 'common';
import { ActivityCodeDoc } from 'src/components';

@Component({
  tag: 'concourse-tag',
  styleUrl: 'concourse-tag.css',
  shadow: true
})
export class ConcourseTag {
  @Prop() projectId: string;
  @Prop() data: TagData;
  @Prop() editable: boolean;

  @State() showPopover: boolean = false;
  @State() popoverEvent: MouseEvent;

  @Event() remove: EventEmitter;

  private activityCodes: ActivityCodeDoc[] = [];

  async componentWillLoad() {
    this.activityCodes = await Tag.getActivityCodesSync(this.projectId);
  }

  /** Finds the first activity code where this tag belongs. */
  get activityCode(): ActivityCodeDoc {
    for (let activity of this.activityCodes)
      if (activity.values.some(item => item.unique_id === this.data.unique_id)) return activity;

    return null;
  }

  /** Find all the parent tags above this tag in the tree */
  get ancestors(): string[] {
    const _ancestors: string[] = [this.data.name];
    for (let tag = this.data; tag = this.findParent(tag);)
      _ancestors.push(tag.name);

    return _ancestors;
  }

  findParent(tag: TagData): TagData {
    return this.activityCode && tag.parent_unique_id ? this.activityCode.values.find(t => t.unique_id && t.unique_id === tag.parent_unique_id) : null;
  }

  /** This is a temporary solution. User defined values should never be referenced in code. */
  get icon(): string {
    if (!this.activityCode) return `🏷️`;
    switch (this.activityCode.name) {
      case 'Area': return `🌏`
      case 'Phase': return `🛩️`
      case 'Responsibility': return `🚂`
      case 'project ID': return `🚀`
      default: return `🏷️`
    }
  }

  get tagPath(): string {
    return this.icon + ' ' + this.ancestors.reverse().join("/");
  }

  onRemoveClick(e: Event) {
    e.stopPropagation();
    this.remove.emit();
  }

  render() {
    return (
      <span onClick={e => e.stopPropagation()}>
        <ion-chip style={{ backgroundColor: this.data.color ?? 'grey' }}>
          <ion-label>{this.tagPath}</ion-label>
          {this.editable && (<ion-icon name='close-circle' onClick={e => this.onRemoveClick(e)} />)}
        </ion-chip>
      </span>
    );
  }
}
